module.exports = __webpack_public_path__ + "static/media/balance.a2ff3807.jpg";